var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkedinIconSmall = function SvgLinkedinIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#4875b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.8105,665.5918v29.9531a2.5175,2.5175,0,0,1-2.5,2.5235H704.3027a2.5109,2.5109,0,0,1-2.4922-2.5235V665.5918a2.5108,2.5108,0,0,1,2.4922-2.5234h30.0078A2.5174,2.5174,0,0,1,736.8105,665.5918Zm-24.0078,5.4844a3.0078,3.0078,0,1,0-3.0078,3.0078A3.014,3.014,0,0,0,712.8027,671.0762Zm-.4062,21.9922V676.3652h-5.1953v16.7032h5.1953Zm19.4375-9.1563c0-4.5-.9766-7.9609-6.2266-7.9609a5.4638,5.4638,0,0,0-4.914,2.6953h-.07v-2.2813h-4.9765v16.7032h5.1875v-8.2657c0-2.18.414-4.289,3.1172-4.289,2.6562,0,2.6953,2.4922,2.6953,4.43v8.125h5.1875Z",
    transform: "translate(-701.8105 -663.0684)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "linkedin-icon-small.3aac9b45ff6c76fac78794c9e5a9fc27.svg";